import { createTheme } from "@mui/material/styles";

// 🎨 Color tokens (only one mode needed)
export const tokens = {
  grey: {
    100: "#fff",
    200: "#f0f0f0",
    300: "#a3a3a3",
    400: "#858585",
    500: "#666666",
    600: "#525252",
    700: "#3d3d3d",
    800: "#292929",
    900: "#141414",
  },
  primary: {
    100: "#d0d1d5",
    200: "#a1a4ab",
    300: "#727681",
    400: "#1F2A40",
    500: "#141b2d",
    600: "#101624",
    700: "#0c101b",
    800: "#080b12",
    900: "#040509",
  },
  redAccent: {
    100: "#ecfdeb",
    200: "#aaffa6",
    300: "#7aff73",
    400: "#0ad600",
  },
  blueAccent: {
    100: "#f1f5f9",
    200: "#80b0e3",
    300: "#356da9",
    400: "#003368",
  },
};

// 🎨 MUI Theme
const theme = createTheme({
  palette: {
    primary: {
      main: tokens.primary[500],
    },
    secondary: {
      main: tokens.blueAccent[300],
    },
    neutral: {
      dark: tokens.grey[700],
      main: tokens.grey[500],
      light: tokens.grey[100],
    },
    background: {
      default: "#fff",
    },
  },
  typography: {
    fontFamily: "Inter, sans-serif", // default for body
    h1: {
      fontFamily: "Nunito, serif",
      fontSize: 40,
    },
    h2: {
      fontFamily: "Nunito, serif",
      fontSize: 25,
    },
    h3: {
      fontFamily: "Nunito, serif",
      fontSize: 20,
    },
    h4: {
      fontFamily: "Nunito, serif",
      fontSize: 20,
    },
    h5: {
      fontFamily: "Nunito, serif",
      fontSize: 16,
    },
    h6: {
      fontFamily: "Nunito, serif",
      fontSize: 14,
    },
    body1: {
      fontFamily: "Inter, sans-serif",
    },
    body2: {
      fontFamily: "Inter, sans-serif",
    },
  },
});

export default theme;
